var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 11.3333C10.2985 11.3333 10 11.6318 10 12C10 12.3682 10.2985 12.6667 10.6667 12.6667C11.0349 12.6667 11.3333 12.3682 11.3333 12C11.3333 11.6318 11.0349 11.3333 10.6667 11.3333Z",
    fill: "currentFill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99992 1.33332C3.99992 0.965136 4.2984 0.666656 4.66658 0.666656C5.03477 0.666656 5.33325 0.965136 5.33325 1.33332V1.99999H10.6666V1.33332C10.6666 0.965136 10.9651 0.666656 11.3333 0.666656C11.7015 0.666656 11.9999 0.965136 11.9999 1.33332V1.99999H12.6666C13.7712 1.99999 14.6666 2.89542 14.6666 3.99999V13.3333C14.6666 14.4379 13.7712 15.3333 12.6666 15.3333H3.33325C2.22869 15.3333 1.33325 14.4379 1.33325 13.3333V3.99999C1.33325 2.89542 2.22869 1.99999 3.33325 1.99999H3.99992V1.33332ZM10.6666 3.33332V3.99999C10.6666 4.36818 10.9651 4.66666 11.3333 4.66666C11.7015 4.66666 11.9999 4.36818 11.9999 3.99999V3.33332H12.6666C13.0348 3.33332 13.3333 3.6318 13.3333 3.99999V5.99999H2.66659V3.99999C2.66659 3.6318 2.96507 3.33332 3.33325 3.33332H3.99992V3.99999C3.99992 4.36818 4.2984 4.66666 4.66658 4.66666C5.03477 4.66666 5.33325 4.36818 5.33325 3.99999V3.33332H10.6666ZM2.66659 7.33332V13.3333C2.66659 13.7015 2.96507 14 3.33325 14H12.6666C13.0348 14 13.3333 13.7015 13.3333 13.3333V7.33332H2.66659Z",
    fill: "currentFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/DateIcon.5da0590e07ce88f38e6401c286775330.svg";
export { ForwardRef as ReactComponent };